import { isPatronPro } from "./tier-spots";

/** Patron / Explorer PRO helpers — backend uses `tier: "pro"`. */
export function isProUser(user) {
  return isPatronPro(user);
}

export function patronTierLabel(user) {
  return isProUser(user) ? "Explorer PRO" : "Free";
}
